// extracted by mini-css-extract-plugin
export default {"pageView":"page-view_pageView__eW4ok"};